import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./Pages/Home/Home";
import Portfolio from "./Pages/Portfolio/Portfolio";
import WorkshopsPage from "./Pages/Workshops/Workshops";
import UpcomingEventsPage from "./Pages/UpcomingEvents/UpcomingEvents";
import PreviousEventsPage from "./Pages/PreviousEvents/PreviousEvents";
import Navbar from "./Components/NavBar/Navbar";
import styles from "./App.module.css";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <div className={styles.App}>
      <Analytics />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route
            path="/events"
            element={<Navigate to="/upcoming-events" replace />}
          />
          <Route
            path="/workshops"
            element={<Navigate to="/example-workshops" replace />}
          />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/example-workshops" element={<WorkshopsPage />} />
          <Route path="/upcoming-events" element={<UpcomingEventsPage />} />
          <Route path="/previous-events" element={<PreviousEventsPage />} />
        </Routes>
      </Router>
      <div className={styles.footer}>
        Website and photography | Matthew Speechley 2023
      </div>
    </div>
  );
}

export default App;
